module.exports = __webpack_public_path__ + "img/b31439434a9da4f16bb6018013d06fdb.png";